import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import SortOrder from '@/constants/SortOrder';
import prependPrefix from '@/utils/prependPrefix';
import CommonParams from '../constants/CommonParams';
import type SortableFields from '../types/SortableFields';

const { SORT_BY, SORT_ORDER } = CommonParams;

const parseSortableFields = (
  sortableFields: SortableFields,
  urlSearch: URLSearchParams,
  prefix?: string,
) => {
  const sortByFromSearch = urlSearch.get(
    snakeCase(prependPrefix(SORT_BY, prefix)),
  );
  const sortOrderFromSearch = urlSearch.get(
    snakeCase(prependPrefix(SORT_ORDER, prefix)),
  );
  const fieldName =
    sortByFromSearch && camelCase(sortByFromSearch) in sortableFields
      ? camelCase(sortByFromSearch)
      : Object.keys(sortableFields).find(
          (key) => sortableFields[key].isDefault,
        ) || Object.keys(sortableFields)[0];
  return {
    [SORT_BY]: snakeCase(fieldName),
    [SORT_ORDER]:
      sortOrderFromSearch ||
      sortableFields[fieldName].defaultValue ||
      SortOrder.ASC,
  };
};

export default parseSortableFields;
